import React from 'react';

import {
  Box,
  styled,
  TablePagination as BaseTablePagination
} from '@mui/material';



const ContainerBox = styled(Box)({
  display: 'flex',
  alignItems: 'center'
});

const TablePagination = styled(BaseTablePagination)({
  display: 'flex'
});



export interface IPaginationControlProps {
  pageSize: number;
  rowCount: number;

  onClickPrevious: () => void;
  onClickNext: () => void;
}

export const GooglePaginationControl: React.FC<IPaginationControlProps> = props => {
  const [page, setPage] = React.useState(0);

  return (
    <ContainerBox>
      <TablePagination
        count={props.rowCount}
        page={page}
        rowsPerPageOptions={[]}
        onPageChange={(event, value) => {
          if (value < page) {
            props.onClickPrevious();
          } else if (value > page) {
            props.onClickNext();
          }

          setPage(value);
        }}
        rowsPerPage={props.pageSize}
      />
    </ContainerBox>
  );
};
